import { post } from "api"

export const sendNotification = (payload) => async (dispatch) => {
  return post({
    subUrl: "/notification/notify",
    data: payload
  });
};